import { ReactElement } from "react";
import { NotFoundPage } from "../presentation/screens/not-found/NotFoundPage";
import { useIsOrdersTodayAdmin } from "./useIsOrdersTodayAdmin";

interface Props {
  element: JSX.Element;
}

/**
 * Inside AuthRoute(Role.Admin) on /admin/orders-today: an admin who is not
 * on REACT_APP_ORDERS_TODAY_ADMIN_EMAILS gets "not found" (like
 * ApiKeyAdminRoute). Allowed - or the list unset - renders the screen
 * exactly as today.
 */
export function OrdersTodayAdminGate({ element }: Props): ReactElement {
  return useIsOrdersTodayAdmin() ? element : <NotFoundPage />;
}
